import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';

import JobTaskGeneric from './JobTaskGeneric';
import JobTaskMaintenance from './JobTaskMaintenance';
import JobTaskSimple from './JobTaskSimple';

import { Section } from '../../ContentEdit';

import { startAddBidTask } from '../../../../store/actions/bids';
import { startEditBidEditorState } from '../../../../store/actions/bidEditor';

import {
  helpDispatch,
  OverlayElevator,
  Tooltip,
  TooltipTypes
} from 'components/admin/Help';

const styles = theme => ({
  elevate: {
    position: 'relative',
    zIndex: theme.zIndex.tooltipAction,
    backgroundColor: '#fff',
    borderRadius: '5px',
  }
});

const JobTasks = (props) => {
  const {
    classes,
    type,
    bid,
    preview,
    bidTasks,
    bidValidation,
    showValidation,
    startAddBidTask,
    startEditBidEditorState,
    help
  } = props;

  const { showTasks = false } = bid.template;

  return(
    <Section
      error={(showValidation && bidValidation.validateField("missingTasks"))}
      preview={preview}
      title="Job Tasks"
      showContent={showTasks}
      showAdd
      tooltipType={TooltipTypes.bid.ADD_TASK_SIMPLE}
      menuItems={[
          {
            title: "Simple",
            action: startAddBidTask,
            payload: {type: 'simple', bidId: bid.id},
            editorState: () => startEditBidEditorState("jobTasksSimpleButton"),
          },
          {
            title: "Estimate",
            action: startAddBidTask,
            payload: {type: 'estimate', bidId: bid.id},
            editorState: () => startEditBidEditorState("jobTasksEstimateButton"),
          },
          {
            title: "Quote",
            action: startAddBidTask,
            payload: {type: 'quote', bidId: bid.id},
            editorState: () => startEditBidEditorState("jobTasksQuoteButton"),
          },
          {
            type: "divider",
          },
          {
            title: "Recurring",
            action: startAddBidTask,
            payload: {type: 'maintenance', bidId: bid.id, scheduleStart: (new Date()).getTime()},
            editorState: () => startEditBidEditorState("jobTasksRecurringButton"),
          }
    ]}>
      <Tooltip type={TooltipTypes.bid.ENTER_INFO_TASK} placement="top">
        <div className={help.isCurrentStep(TooltipTypes.bid.ENTER_INFO_TASK) && classes.elevate}>
          {bidTasks.map((bidTask) => {
            if (bidTask.type === "maintenance") {
              return <JobTaskMaintenance preview={preview} key={bidTask.id} bidTask={bidTask} />
            } else if (bidTask.type === "simple"){
              return <JobTaskSimple preview={preview} key={bidTask.id} bidTask={bidTask} />
            } else {
              return <JobTaskGeneric preview={preview} key={bidTask.id} bidTask={bidTask} />
            }
          })}
        </div>
      </Tooltip>
    </Section>
  );
};

JobTasks.defaultProps = {
  bid: {
    template: {}
  }
};

//TODO: use reselect for bidTasks so that they only reload when specific bidTasks change
const mapStateToProps = (state) => {
  const { id: bidId, showValidation } = state.adminState.bid;
  const bidValidation = state.validation.bids.find(item => item.id === bidId);
  return({
    bid: state.bidsState.find( bid => bid.id === bidId ),
    bidTasks: state.bidTasksState.filter( bidTask => bidTask.bidId === bidId),
    bidValidation,
    showValidation,
    help: state.help,
  });
};

const mapDispatchToProps = {
  startAddBidTask,
  startEditBidEditorState,
}

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(JobTasks);



// WEBPACK FOOTER //
// ./src/components/admin/Bids/Detail/JobTasks.jsx